import apolloClient from "@src/utilities/apollo-client"

import { CART_SET_SHIPPING_INFO } from "@src/operations/api/cart"

import type {
  SetCartShippingInfoMutation,
  SetCartShippingInfoMutationVariables,
} from "@src/entities/types/api"

export default async function setCartShipping(
  input: SetCartShippingInfoMutationVariables["input"]
) {
  return apolloClient.mutate<
    SetCartShippingInfoMutation,
    SetCartShippingInfoMutationVariables
  >({
    mutation: CART_SET_SHIPPING_INFO,
    variables: { input },
  })
}
